import { Suspense } from "react";
import { Catcher, ERROR_ASIDE, MISSING_ASIDE, PRIVATE_ASIDE } from "../base/Catcher.js";
import { Page } from "../base/Page.js";
import { LOADING_ELEMENT } from "./Loader.js";

export const LOADING_PAGE = (
	<Page status={100} title="Loading...">
		{LOADING_ELEMENT}
	</Page>
);

export const ERROR_PAGE = (
	<Page status={500} title="Error">
		{ERROR_ASIDE}
	</Page>
);

export const PRIVATE_PAGE = (
	<Page status={403} title="Private">
		{PRIVATE_ASIDE}
	</Page>
);

export const MISSING_PAGE = (
	<Page status={404} title="Not found">
		{MISSING_ASIDE}
	</Page>
);

/**
 * Load a page.
 * - Wrapped in `<PageCatcher>` so child components can throw errors.
 * - Wrapped in `<Suspense>` so child components can throw promises.
 */
export function PageLoader({ children }: { children: React.ReactNode }): React.ReactElement {
	return (
		<Catcher error={ERROR_PAGE} forbidden={PRIVATE_PAGE} required={MISSING_PAGE}>
			<Suspense fallback={LOADING_PAGE}>{children}</Suspense>
		</Catcher>
	);
}
